import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { AccountService } from '../../service/data/account.service';
import { LanguageService } from '../../../core/service/language.service';
import { MessageService } from '../../../core/service/message.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { Landlord } from '../../../landlord/model/landlord';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-register-demo',
    templateUrl: './register-demo.component.html',
    styleUrls: ['./register-demo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegisterDemoComponent implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private _controlModelFactory: FormControlExFactory,
    private _accountService: AccountService,
    private _languageService: LanguageService,
    private _messageService: MessageService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _companyService: CompanyService
  ) {
    this.dataContext = new Landlord();
    this.completed = false;
    this.workInProgress = false;
  }

  readonly dataContext: Landlord;
  form: FormGroup;

  public completed: boolean;

  private _createForm() {
    this.form = this._fb.group({
      address: this._fb.group({}),
      name: this._controlModelFactory.createWithOptions('LANDLORD.COMPANY', this.dataContext.name, { required: true }),
      email: this._controlModelFactory.createWithOptions('COMMON.EMAIL_ADDRESS', this.dataContext.email, { required: true }),
      phone: this._controlModelFactory.createWithOptions('LANDLORD.PHONE', this.dataContext.phone, { length: 20, required: true }),
      organizationNo: this._controlModelFactory.createMandatory('LANDLORD.ORGANIZATION_NUMBER', this.dataContext.orgNumber),
      referenceName: this._controlModelFactory.createMandatory('LANDLORD.REFERENCE_NAME', this.dataContext.referenceName),
    });
  }

  ngOnInit() {
    this._createForm();
  }

  public workInProgress: boolean;

  onSubmit() {
    if (this.workInProgress) return;

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.workInProgress = true;

    this._accountService.registerDemoAccount(this.form.value).subscribe(
      () => (this.completed = true),
      error => {
        this.workInProgress = false;
        this._messageService.showError(error);
      }
    );
  }
}
